import * as types from "../actions/types";


const initialState = {
    forms: null,
    secondaryforms: null
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_FORMS_COMPLETED:
            return Object.assign({}, state, {
                forms: action.payload
            });
        case types.GET_FORMS_SECONDARY_COMPLETED:
            return Object.assign({}, state, {
                secondaryforms: action.payload
            });
        default:
            return state;
    }
};
